import { render, staticRenderFns } from "./BoxAtividadesAguardandoAprovacao.vue?vue&type=template&id=6a552e68"
import script from "./BoxAtividadesAguardandoAprovacao.vue?vue&type=script&lang=js"
export * from "./BoxAtividadesAguardandoAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports